import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { changeMyPassword } from '../services/authService';
import { RSMIN_APP_URL } from '../config';
import './AccountPage.css';

export default function AccountPage() {
  const { user, logout } = useAuth();
  const { tenantSlug } = useParams();
  const navigate = useNavigate();
  const [passwords, setPasswords] = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const rsminLinked = !!user?.externalIdentifiers?.rsmin?.userId;

  const changePassword = async (event) => {
    event.preventDefault();
    setError('');
    if (passwords.newPassword !== passwords.confirmPassword) {
      setError('New passwords do not match.');
      return;
    }
    setSaving(true);
    try {
      await changeMyPassword({ currentPassword: passwords.currentPassword, newPassword: passwords.newPassword });
      setPasswords({ currentPassword: '', newPassword: '', confirmPassword: '' });
      await logout();
      navigate(tenantSlug ? `/t/${tenantSlug}/login` : '/login',
        { replace: true, state: { passwordChanged: true } });
    } catch (err) {
      setError(err.response?.data?.message || 'Unable to change your password. Please retry.');
    } finally {
      setSaving(false);
    }
  };
  return (
    <div className="page account-page">
      <h1>Account settings</h1>
      <section className="account-card" aria-label="Account details">
        <h2>Your details</h2>
        <dl><dt>Name</dt><dd>{[user?.firstName, user?.lastName].filter(Boolean).join(' ') || 'Not provided'}</dd>
          <dt>Email</dt><dd>{user?.email?.endsWith('@bridge.local') ? 'RSMIN-linked account (no email provided)' : user?.email}</dd>
          <dt>Sign-in</dt><dd>{rsminLinked ? 'Linked to RSMIN' : 'CIP email and password'}</dd></dl>
      </section>
      <section className="account-card" aria-label="Change password">
        <h2>Change CIP password</h2>
        {rsminLinked && <p>Your RSMIN password is managed in RSMIN, not here.
          {' '}{RSMIN_APP_URL && <a href={RSMIN_APP_URL} target="_blank" rel="noopener noreferrer">Open RSMIN</a>}
          {' '}Only use this form if you already have a CIP password. RSMIN-only accounts do not need one.</p>}
        <form onSubmit={changePassword}>
          <label htmlFor="current-password">Current CIP password</label>
          <input id="current-password" type="password" autoComplete="current-password" required
            disabled={saving} value={passwords.currentPassword}
            onChange={(event) => setPasswords({ ...passwords, currentPassword: event.target.value })} />
          <label htmlFor="new-password">New CIP password</label>
          <input id="new-password" type="password" autoComplete="new-password" minLength={8} required
            disabled={saving} value={passwords.newPassword}
            onChange={(event) => setPasswords({ ...passwords, newPassword: event.target.value })} />
          <label htmlFor="confirm-password">Confirm new password</label>
          <input id="confirm-password" type="password" autoComplete="new-password" minLength={8} required
            disabled={saving} value={passwords.confirmPassword}
            onChange={(event) => setPasswords({ ...passwords, confirmPassword: event.target.value })} />
          <small>At least 8 characters, up to 72 UTF-8 bytes. Changing your password signs out your CIP sessions.</small>
          {error && <p role="alert">{error}</p>}
          <button disabled={saving} type="submit">{saving ? 'Changing password...' : 'Change password'}</button>
        </form>
      </section>
    </div>
  );
}
